import { createSlice } from "@reduxjs/toolkit";
import { reKyc_SendRequestThunk } from "./thunk";

export const initialState = {
  reKyc_SendRequestApplicationData: [],
  reKyc_SendRequestApplicationError: "", // for error message
  reKyc_SendRequestApplicationLoading: false,
};

const Re_Kyc_Send_Request_Application = createSlice({
  name: "Re_Kyc_Send_Request_Application",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(reKyc_SendRequestThunk.pending, (state) => {
      state.reKyc_SendRequestApplicationLoading = true;
      state.reKyc_SendRequestApplicationData = [];
      state.reKyc_SendRequestApplicationError = "";
    });
    builder.addCase(reKyc_SendRequestThunk.fulfilled, (state, action) => {
      state.reKyc_SendRequestApplicationData = action.payload.data;
      state.reKyc_SendRequestApplicationLoading = false;
    });
    builder.addCase(reKyc_SendRequestThunk.rejected, (state, action) => {
      state.reKyc_SendRequestApplicationError =
        action.error?.message ||
        action.payload?.message ||
        "An unknown error occurred";
      state.reKyc_SendRequestApplicationLoading = false;
    });
  },
});

export const { apiRequest, apiError } = Re_Kyc_Send_Request_Application.actions;

export default Re_Kyc_Send_Request_Application.reducer;
